
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retailers",
      function () {
        return require("private-next-pages/retailers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retailers"])
      });
    }
  